import { render, staticRenderFns } from "./ProductSearch.vue?vue&type=template&id=0b5eeed8&"
import script from "./ProductSearch.ts?vue&type=script&lang=ts&"
export * from "./ProductSearch.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports